import { SmsUsaRegistrationBusinessIndustry } from '@mews-commander/data-access';
import { BrandRegistrationFormValues, BusinessContact, CustomerProfile, CustomerProfileAddress } from './types';

const defaultAddressValues: CustomerProfileAddress = {
    addressLine1: '',
    addressLine2: '',
    city: '',
    postalCode: '',
    countryCode: '',
    countrySubdivisionCode: '',
};

interface GetCustomerProfileDefaultValuesOptions {
    websiteUrl: string;
    businessIndustry: SmsUsaRegistrationBusinessIndustry;
}

const getCustomerProfileDefaultValues = ({
    businessIndustry,
    websiteUrl,
}: GetCustomerProfileDefaultValuesOptions): CustomerProfile => ({
    businessIndustry,
    businessName: '',
    businessRegionsOfOperation: [],
    businessRegistrationIdentifier: '',
    businessRegistrationNumber: '',
    businessType: '',
    websiteUrl,
});

const businessContactDefaultValues: BusinessContact = {
    firstName: '',
    lastName: '',
    jobTitle: '',
    jobPosition: '',
    phoneNumber: '',
    email: '',
};

export const getDefaultValues = ({
    businessIndustry,
    websiteUrl,
}: GetCustomerProfileDefaultValuesOptions): BrandRegistrationFormValues => ({
    ...getCustomerProfileDefaultValues({ businessIndustry, websiteUrl }),
    ...defaultAddressValues,
    ...businessContactDefaultValues,
    termsAndConditions: false,
});
